export default __webpack_public_path__ + "static/plate-5e4e291e9b70ca2de84908b6352d664c.png";